export function RulerIcon({ width = 20 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      x="0"
      y="0"
      viewBox="0 0 24 24"
    >
      <path d="m 1.0398319,13.767767 c -1.17156512,1.171565 -1.17156512,3.071076 0,4.242641 l 4.9497475,4.949747 c 1.1715995,1.1716 3.0710756,1.171565 4.2426406,0 L 22.960142,10.232233 c 1.1716,-1.1715995 1.1716,-3.0710411 0,-4.2426406 L 18.010395,1.0398449 c -1.171565,-1.17156509 -3.071041,-1.1715996 -4.242641,0 z m 2.8284271,0 1.4142136,-1.414214 3.5355339,3.535534 c 0.3905322,0.390533 0.3905192,1.023695 0,1.414214 -0.3905193,0.390519 -1.0236813,0.390532 -1.4142136,0 z M 6.6966861,10.93934 8.1108997,9.525126 10.23222,11.646447 c 0.390534,0.390534 0.390534,1.023679 0,1.414213 -0.3905275,0.390528 -1.0236791,0.390535 -1.4142135,0 z M 9.5251133,8.1109127 10.939327,6.6966991 14.474861,10.232233 c 0.390533,0.390534 0.390533,1.02368 0,1.414214 -0.390534,0.390533 -1.02368,0.390533 -1.414214,0 z M 12.35354,5.2824856 13.767754,3.868272 l 2.12132,2.1213204 c 0.390533,0.3905329 0.390533,1.0236806 0,1.4142135 -0.390533,0.390533 -1.02368,0.390533 -1.414213,0 z" />
    </svg>
  );
}
